import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import { profitItemDefSchema, variableSchema } from './entities';

export const types = {
  DELETE_PROFIT_ITEM_ERROR: 'profitItems/detailsPage/DELETE_PROFIT_ITEM_ERROR',
  DELETE_PROFIT_ITEM_REQUEST:
    'profitItems/detailsPage/DELETE_PROFIT_ITEM_REQUEST',
  DELETE_PROFIT_ITEM_SUCCESS:
    'profitItems/detailsPage/DELETE_PROFIT_ITEM_SUCCESS',

  FORMULA_OPEN_MODAL: 'profitItems/detailsPage/FORMULA_OPEN_MODAL',
  FORMULA_CLOSE_MODAL: 'profitItems/detailsPage/FORMULA_CLOSE_MODAL',
  FORMULA_COMPILE_REQUEST: 'profitItems/detailsPage/FORMULA_COMPILE_REQUEST',
  FORMULA_COMPILE_SUCCESS: 'profitItems/detailsPage/FORMULA_COMPILE_SUCCESS',
  FORMULA_COMPILE_ERROR: 'profitItems/detailsPage/FORMULA_COMPILE_ERROR',
  FORMULA_UPDATE_REQUEST: 'profitItems/detailsPage/FORMULA_UPDATE_REQUEST',
  FORMULA_UPDATE_SUCCESS: 'profitItems/detailsPage/FORMULA_UPDATE_SUCCESS',
  FORMULA_UPDATE_ERROR: 'profitItems/detailsPage/FORMULA_UPDATE_ERROR',
  FORMULA_RESET_MESSAGE: 'proitItems/detailsPage/FORMULA_RESET_MESSAGE',

  RECEIVE_PROFIT_ITEM: 'profitItems/detailsPage/RECEIVE_PROFIT_ITEM',

  UPDATE_PROFIT_ITEM_ERROR: 'profitItems/detailsPage/UPDATE_PROFIT_ITEM_ERROR',
  UPDATE_PROFIT_ITEM_REQUEST:
    'profitItems/detailsPage/UPDATE_PROFIT_ITEM_REQUEST',
  UPDATE_PROFIT_ITEM_SUCCESS:
    'profitItems/detailsPage/UPDATE_PROFIT_ITEM_SUCCESS',

  UPDATE_VARIABLE_ERROR: 'profitItems/detailsPage/UPDATE_VARIABLE_ERROR',
  UPDATE_VARIABLE_REQUEST: 'profitItems/detailsPage/UPDATE_VARIABLE_REQUEST',
  UPDATE_VARIABLE_SUCCESS: 'profitItems/detailsPage/UPDATE_VARIABLE_SUCCESS',
};

export const deleteProfitItem = {
  error: notify(
    (error) => ({
      type: types.DELETE_PROFIT_ITEM_ERROR,
      payload: error,
    }),
    'Failed to delete Pricing Item',
  ),
  request: () => ({
    type: types.DELETE_PROFIT_ITEM_REQUEST,
  }),
  success: notify(
    () => ({
      type: types.DELETE_PROFIT_ITEM_SUCCESS,
    }),
    'Successfully deleted Pricing Item',
  ),
};

export const entities = {
  receiveProfitItem: ({ profitItem }) => ({
    type: types.RECEIVE_PROFIT_ITEM,
    payload: normalize(profitItem, profitItemDefSchema),
  }),
};

export const formulaEdit = {
  openModal: () => ({
    type: types.FORMULA_OPEN_MODAL,
  }),
  closeModal: () => ({
    type: types.FORMULA_CLOSE_MODAL,
  }),
  compileRequest: ({ formula }) => ({
    type: types.FORMULA_COMPILE_REQUEST,
    payload: { formula },
  }),
  compileSuccess: () => ({
    type: types.FORMULA_COMPILE_SUCCESS,
  }),
  compileError: ({ error }) => ({
    type: types.FORMULA_COMPILE_ERROR,
    payload: { error },
  }),
  updateRequest: ({ formula, revertedFrom }) => ({
    type: types.FORMULA_UPDATE_REQUEST,
    payload: { formula, revertedFrom },
  }),
  updateSuccess: ({ formula }) => ({
    type: types.FORMULA_UPDATE_SUCCESS,
    payload: { formula },
  }),
  updateError: ({ error }) => ({
    type: types.FORMULA_UPDATE_ERROR,
    payload: { error },
  }),
  resetFormulaMessage: () => ({
    type: types.FORMULA_RESET_MESSAGE,
  }),
};

export const updateProfitItem = {
  error: notify(
    (error) => ({
      type: types.UPDATE_PROFIT_ITEM_ERROR,
      payload: error,
    }),
    'Failed to save Pricing Item',
  ),
  request: ({ profitItemId, data }) => ({
    type: types.UPDATE_PROFIT_ITEM_REQUEST,
    payload: { profitItemId, data },
  }),
  success: ({ profitItem }) => ({
    type: types.UPDATE_PROFIT_ITEM_SUCCESS,
    payload: normalize(profitItem, profitItemDefSchema),
  }),
};

export const updateVariable = {
  error: notify(
    (error) => ({
      type: types.UPDATE_VARIABLE_ERROR,
      payload: error,
    }),
    'Failed to save pricing input',
  ),
  request: ({ variableId, data }) => ({
    type: types.UPDATE_VARIABLE_REQUEST,
    payload: { variableId, data },
  }),
  success: ({ variable }) => ({
    type: types.UPDATE_VARIABLE_SUCCESS,
    payload: normalize(variable, variableSchema),
  }),
};
